import { atom } from "recoil";
import { RecoilKeys } from "../../common/miscellaneous/RecoilKeys";

export interface TaskSubmissionCriteria {
  taskId: number;
  taskName: string;
  dateCompleted: string | null;
  from: string | null;
  to: string | null;
  companyId: string;
  jobTitles: string[] | null;
  jobTitleObjects: Array<{ id: string; title: string }>;
  parentCompanyId: string;
  submittedByUserId: string;
}

export interface TaskSubmissionSearchState {
  criteria: TaskSubmissionCriteria;
  page: number;
  pageSize: number;
  hasSearched: boolean;
}

export const defaultTaskSubmissionCriteria: TaskSubmissionCriteria = {
  taskId: 0,
  taskName: "",
  dateCompleted: null,
  from: null,
  to: null,
  companyId: "",
  jobTitles: null,
  jobTitleObjects: [],
  parentCompanyId: "",
  submittedByUserId: "",
};

export const defaultTaskSubmissionSearchState: TaskSubmissionSearchState = {
  criteria: defaultTaskSubmissionCriteria,
  page: 0,
  pageSize: 25,
  hasSearched: false,
};

export const taskSubmissionSearchAtom = atom<TaskSubmissionSearchState>({
  key: RecoilKeys.TaskSubmissionSearch,
  default: defaultTaskSubmissionSearchState,
});
